import { ResponseType } from 'axios';
import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { InitPayment, ISignOfferLetter, UpdatePaymentResult } from 'src/interfaces/mortgage-deal/mortgage-payment';
import { DTO } from './base.dto';

export class GetOfferLetterDTO extends DTO {
	public param: { mortgageId: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.GET_OFFER_LETTER_INFO;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { mortgageId: string }) {
		super();
		this.param = param;
	}
}

export class SigningOfferDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: ISignOfferLetter;
	public url: string = ENDPOINT.SIGN_OFFER_LETTER;
	public method: HTTP_METHOD = HTTP_METHOD.PUT;
	public readonly responseType: ResponseType = 'json';
	constructor(body: ISignOfferLetter) {
		super();
		this.body = body;
	}
}

export class InitPaymentDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: InitPayment;
	public url: string = ENDPOINT.INIT_PAYMENT;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: InitPayment) {
		super();
		this.body = body;
	}
}

export class UpdatePaymentResultDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: UpdatePaymentResult;
	public url: string = ENDPOINT.SUBMIT_PAYMENT_RESULT;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: UpdatePaymentResult) {
		super();
		this.body = body;
	}
}
